<app-main-nav-bar></app-main-nav-bar>
<div class="page-wrapper bg-red p-t-180 p-b-100 font-robo">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-body">
        <div class="main" data-request="1335">
          <div class="wrap">
            <div class="offer elem" style="display: block;">
              <div class="row">
                <div class="col col-12">
                  <div class="head">
                    <h2>طرح های پیشنهادی سامان</h2>
                    <p>لطفا یکی از طرح های پیشنهادی را انتخاب کنید</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col col-12">
                  <div class="offers">
                    <app-radio-button *ngIf="companyNames.length > 1" [Group]="formGroup" [fieldName]="'companyName'"
                                      [list]="companyNames"></app-radio-button>
                    <div *ngIf="companyOffer && formGroup.controls.companyName.value">
                      <div *ngFor="let healthOffer of companyOffer.companies[formGroup.controls.companyName.value]"
                           class="item">
                        <div class="card" style="text-align: right">
                          <div class="touch"><label class="checkbox">
                            <input (change)="onSelectionChange(healthOffer.getOfferID())"
                                   name="health-offer" type="radio" value="1" class="input input-health-offer">
                            <span>{{healthOffer.getOfferName()}}</span></label>
                            <div class="info" id="{{healthOffer.getOfferID()}}">
                              <div *ngFor="let item of healthOffer.getList()">
                                <div *ngIf="item.getPersianLabel() !== '0'" class="row">
                                  <div class="col col-7"><span>{{item.getValue()}}</span></div>
                                  <div class="col col-5"><span [ngClass]="item.getValue() !== 'نام شرکت' ? 'mark': ''"
                                                               dir="ltr">{{item.getPersianLabel()}}</span>
                                    <span *ngIf="item.getValue() !== 'نام شرکت'">تومان</span>
                                  </div>
                                </div>
                              </div>
                              <div *ngFor="let item of healthOffer.getDiscountsList()" class="row">
                                <div class="discounts">
                                  <span>{{item}}</span>
                                </div>
                              </div>
                            </div>
                            <div class="payment">
                              <div class="row">
                                <div class="col col-6 price-label">
                                  <span>{{healthOffer.getTotalPrice().getValue()}}</span>
                                </div>
                                <div class="col col-6">
                                  <div class="amount amount-discount"
                                       *ngIf="healthOffer.getOriginalPrice().getPersianLabel() !== healthOffer.getTotalPrice().getPersianLabel()">
                                    <span class="mark old-price"
                                          dir="ltr">{{healthOffer.getOriginalPrice().getPersianLabel()}}</span>
                                    <span>تومان</span>
                                  </div>
                                  <div
                                    [ngClass]="healthOffer.getOriginalPrice().getPersianLabel() !== healthOffer.getTotalPrice().getPersianLabel() ? 'amount' : ''">
                                    <span class="mark"
                                          dir="ltr">{{healthOffer.getTotalPrice().getPersianLabel()}}</span>
                                    <span>تومان</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <app-custom-button [LabelText]="'ادامه روند صدور بیمه'"
                                     (OnClick)="submit()"
                                     [backUrl]="'/health/family/new-request'"
                                     [BackButton]="true"
                                     [HideMainButton]="false"
                                     [Show]="true"
                                     [disabled]="!formGroup.valid"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
